<div class="container mx--none">
  <div class="row mt--md mb--sm">
    <div class="column--12">
      <h2>Remove Adjustment Charges</h2>
      <p class="text--sm text-gray-optional mb--none" *ngIf="companyName">{{ companyName }}</p>
    </div>
  </div>

  <!-- Single mode: flat list -->
  <ng-container *ngIf="mode === 'single'">
    <ng-container *ngIf="shipmentsView.length > 0; else noSurcharges">
      <mat-list>
        <mat-list-item *ngFor="let line of shipmentsView[0].surchargeLines" class="surcharge-list-item">
          <mat-checkbox
            [checked]="selection.isSelected(key(shipmentsView[0].shipmentId, line))"
            (change)="toggle(shipmentsView[0].shipmentId, line)">
            <span class="text--sm">
              <strong>{{ line.code }}</strong> &mdash; {{ line.name }} &mdash;
              <span class="amount">{{ line.amount | currency:'CAD':'symbol-narrow' }}</span>
            </span>
          </mat-checkbox>
        </mat-list-item>
      </mat-list>
    </ng-container>
  </ng-container>

  <!-- Bulk mode: accordion per shipment -->
  <ng-container *ngIf="mode === 'bulk'">
    <ng-container *ngIf="shipmentsView.length > 0; else noSurcharges">
      <mat-accordion multi>
        <mat-expansion-panel *ngFor="let s of shipmentsView" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ s.trackingNumber }} ({{ s.providerName }})</mat-panel-title>
            <mat-panel-description class="panel-summary">
              Adjustment:&nbsp;<span class="amount">{{ s.currentAdjustmentTotal | currency:'CAD':'symbol-narrow' }}</span>
              &nbsp;|&nbsp; {{ s.surchargeLines.length }} charge(s)
            </mat-panel-description>
          </mat-expansion-panel-header>

          <mat-list>
            <mat-list-item *ngFor="let line of s.surchargeLines" class="surcharge-list-item">
              <mat-checkbox
                [checked]="selection.isSelected(key(s.shipmentId, line))"
                (change)="toggle(s.shipmentId, line)">
                <span class="text--sm">
                  <strong>{{ line.code }}</strong> &mdash; {{ line.name }} &mdash;
                  <span class="amount">{{ line.amount | currency:'CAD':'symbol-narrow' }}</span>
                </span>
              </mat-checkbox>
            </mat-list-item>
          </mat-list>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>
  </ng-container>

  <ng-template #noSurcharges>
    <div class="row mt--xl">
      <div class="column--12 align-center">
        <p class="text--sm">No pending removable charges found for this shipment.</p>
      </div>
    </div>
  </ng-template>

  <!-- Removal summary (content) -->
  <div class="row mt--lg">
    <div class="column--12">
      <p class="mb--none">
        <strong>Removing: <span class="amount">{{ runningRemovalTotal | currency:'CAD':'symbol-narrow' }}</span></strong>
      </p>
      <p class="text--sm text-gray-optional mb--none">Taxes will be recalculated server-side</p>
    </div>
  </div>

  <!-- Footer actions: cancel (left) · primary CTA (right), on one baseline below the content -->
  <div class="row mt--md mb--md">
    <div class="column--6">
      <button mat-flat-button color="accent" (click)="cancel()" [disabled]="saving">Cancel</button>
    </div>
    <div class="column--6 align-right">
      <button
        mat-flat-button
        color="warn"
        [disabled]="selection.isEmpty() || saving"
        (click)="save()">
        Remove and recalculate
      </button>
    </div>
  </div>
</div>
